package eu.codlab.weather.common.compose

import eu.codlab.weather.common.compose.res.Res
import eu.codlab.weather.common.compose.res.weather_200
import eu.codlab.weather.common.compose.res.weather_201
import eu.codlab.weather.common.compose.res.weather_202
import eu.codlab.weather.common.compose.res.weather_210
import eu.codlab.weather.common.compose.res.weather_211
import eu.codlab.weather.common.compose.res.weather_212
import eu.codlab.weather.common.compose.res.weather_221
import eu.codlab.weather.common.compose.res.weather_230
import eu.codlab.weather.common.compose.res.weather_231
import eu.codlab.weather.common.compose.res.weather_232
import eu.codlab.weather.common.compose.res.weather_300
import eu.codlab.weather.common.compose.res.weather_301
import eu.codlab.weather.common.compose.res.weather_302
import eu.codlab.weather.common.compose.res.weather_310
import eu.codlab.weather.common.compose.res.weather_311
import eu.codlab.weather.common.compose.res.weather_312
import eu.codlab.weather.common.compose.res.weather_313
import eu.codlab.weather.common.compose.res.weather_314
import eu.codlab.weather.common.compose.res.weather_321
import eu.codlab.weather.common.compose.res.weather_500
import eu.codlab.weather.common.compose.res.weather_501
import eu.codlab.weather.common.compose.res.weather_502
import eu.codlab.weather.common.compose.res.weather_503
import eu.codlab.weather.common.compose.res.weather_504
import eu.codlab.weather.common.compose.res.weather_511
import eu.codlab.weather.common.compose.res.weather_520
import eu.codlab.weather.common.compose.res.weather_521
import eu.codlab.weather.common.compose.res.weather_522
import eu.codlab.weather.common.compose.res.weather_531
import eu.codlab.weather.common.compose.res.weather_600
import eu.codlab.weather.common.compose.res.weather_601
import eu.codlab.weather.common.compose.res.weather_602
import eu.codlab.weather.common.compose.res.weather_611
import eu.codlab.weather.common.compose.res.weather_612
import eu.codlab.weather.common.compose.res.weather_613
import eu.codlab.weather.common.compose.res.weather_615
import eu.codlab.weather.common.compose.res.weather_616
import eu.codlab.weather.common.compose.res.weather_620
import eu.codlab.weather.common.compose.res.weather_621
import eu.codlab.weather.common.compose.res.weather_622
import eu.codlab.weather.common.compose.res.weather_701
import eu.codlab.weather.common.compose.res.weather_711
import eu.codlab.weather.common.compose.res.weather_721
import eu.codlab.weather.common.compose.res.weather_731
import eu.codlab.weather.common.compose.res.weather_741
import eu.codlab.weather.common.compose.res.weather_751
import eu.codlab.weather.common.compose.res.weather_761
import eu.codlab.weather.common.compose.res.weather_762
import eu.codlab.weather.common.compose.res.weather_771
import eu.codlab.weather.common.compose.res.weather_781
import eu.codlab.weather.common.compose.res.weather_800
import eu.codlab.weather.common.compose.res.weather_801
import eu.codlab.weather.common.compose.res.weather_802
import eu.codlab.weather.common.compose.res.weather_803
import eu.codlab.weather.common.compose.res.weather_804
import eu.codlab.weather.common.compose.res.weather_title_clouds
import eu.codlab.weather.common.compose.res.weather_title_drizzle
import eu.codlab.weather.common.compose.res.weather_title_rain
import eu.codlab.weather.common.compose.res.weather_title_snow
import eu.codlab.weather.common.compose.res.weather_title_thunderstorm
import eu.codlab.weather.common.models.WeatherConditionMap
import org.jetbrains.compose.resources.StringResource

val WeatherConditionMap.stringResourceExplanation: Pair<StringResource, StringResource?>
    get() = when (this) {
        WeatherConditionMap.ThunderstormWithHeavyRain -> Res.string.weather_title_thunderstorm to Res.string.weather_202
        WeatherConditionMap.ThunderstormWithLightRain -> Res.string.weather_title_thunderstorm to Res.string.weather_200
        WeatherConditionMap.ThunderstormWithRain -> Res.string.weather_title_thunderstorm to Res.string.weather_201
        WeatherConditionMap.ThunderstormLight -> Res.string.weather_title_thunderstorm to Res.string.weather_210
        WeatherConditionMap.Thunderstorm -> Res.string.weather_title_thunderstorm to Res.string.weather_211
        WeatherConditionMap.ThunderstormHeavy -> Res.string.weather_title_thunderstorm to Res.string.weather_212
        WeatherConditionMap.ThunderstormRagged -> Res.string.weather_title_thunderstorm to Res.string.weather_221
        WeatherConditionMap.ThunderstormWithLightDrizzle -> Res.string.weather_title_thunderstorm to Res.string.weather_230
        WeatherConditionMap.ThunderstormWithDrizzle -> Res.string.weather_title_thunderstorm to Res.string.weather_231
        WeatherConditionMap.ThunderstormWithHeavyDrizzle -> Res.string.weather_title_thunderstorm to Res.string.weather_232
        WeatherConditionMap.DrizzleLightIntensity -> Res.string.weather_title_drizzle to Res.string.weather_300
        WeatherConditionMap.Drizzle -> Res.string.weather_title_drizzle to Res.string.weather_301
        WeatherConditionMap.DrizzleHeavyIntensity -> Res.string.weather_title_drizzle to Res.string.weather_302
        WeatherConditionMap.DrizzleLightIntensityRain -> Res.string.weather_title_drizzle to Res.string.weather_310
        WeatherConditionMap.DrizzleRain -> Res.string.weather_title_drizzle to Res.string.weather_311
        WeatherConditionMap.DrizzleHeavyIntensityRain -> Res.string.weather_title_drizzle to Res.string.weather_312
        WeatherConditionMap.DrizzleShowerRain -> Res.string.weather_title_drizzle to Res.string.weather_313
        WeatherConditionMap.DrizzleHeavyShowerRain -> Res.string.weather_title_drizzle to Res.string.weather_314
        WeatherConditionMap.DrizzleShower -> Res.string.weather_title_drizzle to Res.string.weather_321
        WeatherConditionMap.RainLight -> Res.string.weather_title_rain to Res.string.weather_500
        WeatherConditionMap.RainModerate -> Res.string.weather_title_rain to Res.string.weather_501
        WeatherConditionMap.RainHeavyIntensity -> Res.string.weather_title_rain to Res.string.weather_502
        WeatherConditionMap.RainVeryHeavy -> Res.string.weather_title_rain to Res.string.weather_503
        WeatherConditionMap.RainExtreme -> Res.string.weather_title_rain to Res.string.weather_504
        WeatherConditionMap.RainFreezing -> Res.string.weather_title_rain to Res.string.weather_511
        WeatherConditionMap.RainLightIntensityShower -> Res.string.weather_title_rain to Res.string.weather_520
        WeatherConditionMap.RainShower -> Res.string.weather_title_rain to Res.string.weather_521
        WeatherConditionMap.RainHeavyIntensityShower -> Res.string.weather_title_rain to Res.string.weather_522
        WeatherConditionMap.RainRaggedShower -> Res.string.weather_title_rain to Res.string.weather_531
        WeatherConditionMap.SnowLight -> Res.string.weather_title_snow to Res.string.weather_600
        WeatherConditionMap.Snow -> Res.string.weather_title_snow to Res.string.weather_601
        WeatherConditionMap.SnowHeavy -> Res.string.weather_title_snow to Res.string.weather_602
        WeatherConditionMap.SnowSleet -> Res.string.weather_title_snow to Res.string.weather_611
        WeatherConditionMap.SnowSleetLightShower -> Res.string.weather_title_snow to Res.string.weather_612
        WeatherConditionMap.SnowShowerSleet -> Res.string.weather_title_snow to Res.string.weather_613
        WeatherConditionMap.SnowAndLightRain -> Res.string.weather_title_snow to Res.string.weather_615
        WeatherConditionMap.SnowAndRain -> Res.string.weather_title_snow to Res.string.weather_616
        WeatherConditionMap.SnowLightShower -> Res.string.weather_title_snow to Res.string.weather_620
        WeatherConditionMap.SnowShower -> Res.string.weather_title_snow to Res.string.weather_621
        WeatherConditionMap.SnowHeavyShower -> Res.string.weather_title_snow to Res.string.weather_622
        WeatherConditionMap.Mist -> Res.string.weather_701 to null
        WeatherConditionMap.Smoke -> Res.string.weather_711 to null
        WeatherConditionMap.Haze -> Res.string.weather_721 to null
        WeatherConditionMap.DustSandWhirls -> Res.string.weather_731 to null
        WeatherConditionMap.Fog -> Res.string.weather_741 to null
        WeatherConditionMap.Sand -> Res.string.weather_751 to null
        WeatherConditionMap.Dust -> Res.string.weather_761 to null
        WeatherConditionMap.Ash -> Res.string.weather_762 to null
        WeatherConditionMap.Squall -> Res.string.weather_771 to null
        WeatherConditionMap.Tornado -> Res.string.weather_781 to null
        WeatherConditionMap.Clear -> Res.string.weather_800 to null
        WeatherConditionMap.CloudsFew -> Res.string.weather_title_clouds to Res.string.weather_801
        WeatherConditionMap.CloudsScattered -> Res.string.weather_title_clouds to Res.string.weather_802
        WeatherConditionMap.CloudsBroken -> Res.string.weather_title_clouds to Res.string.weather_803
        WeatherConditionMap.CloudsOvercast -> Res.string.weather_title_clouds to Res.string.weather_804
    }
